import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { VOICE_PROFILE_URL } from '@utils/api/endpoints.voice-profiles.ts';
import { VoiceProfileSampleList } from '@utils/types/organization/voice-profile.ts';
import { VOICE_PROFILE_QUERY_KEYS } from './query-keys.ts';

/** One directory speaker's enrolled samples — metadata only.
 *
 * Samples hold encrypted embeddings, not retained recordings, so there is
 * nothing here to play back; the UI lists labels, dates and consent
 * bookkeeping. Admin-only on the backend, so callers pass `enabled: false`
 * for non-admins rather than provoking a 403. */
export const useGetVoiceSamples = (
  speakerId: number | null | undefined,
  enabled = true
) =>
  useQuery<VoiceProfileSampleList>(
    VOICE_PROFILE_QUERY_KEYS.samples(speakerId ?? 0),
    async () => {
      const { data } = await Axios.get<VoiceProfileSampleList>(
        VOICE_PROFILE_URL.samples(speakerId as number)
      );
      return data;
    },
    {
      enabled: enabled && typeof speakerId === 'number' && speakerId > 0,
      retry: false,
      useErrorBoundary: false
    }
  );
